import { Component } from 'react';
import PropTypes from 'prop-types';


const propTypes = {
  event: PropTypes.string.isRequired,
  onEvent: PropTypes.func.isRequired,
};

// This will register an window event listener
// It is recommended you do not change the event/event handler after
// this component has been initialized. (So do not use anonymous functions.)
export default class WindowEventListener extends Component {
  componentDidMount() {
    const { event, onEvent } = this.props;
    window.addEventListener(event, onEvent, false);
  }

  componentDidUpdate(previousProps) {
    const { event, onEvent } = this.props;
    if (previousProps.event !== event || previousProps.onEvent !== onEvent) {
      window.removeEventListener(previousProps.event, previousProps.onEvent);
      window.addEventListener(event, onEvent, false);
      console.log("Warning: You should not be changing WindowEventListener's props frequently.");
    }
  }

  componentWillUnmount() {
    const { event, onEvent } = this.props;
    window.removeEventListener(event, onEvent);
  }

  render() {
    return null;
  }
}

WindowEventListener.propTypes = propTypes;
